export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-background-50/10 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-[250px] h-[250px] bg-accent-500/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3 pointer-events-none"></div>

          <div className="relative z-10 flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-black text-background-50 mb-3">酷看漫画 App</h2>
            <p className="text-sm md:text-base text-background-50/85 leading-relaxed mb-6 max-w-lg">
              专为漫画爱好者打造的移动阅读体验。随时随地畅享韩漫、日漫、国漫，支持离线下载、收藏同步、阅读进度云存储。界面简洁流畅，滑动翻页如丝般顺滑。
            </p>
            <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 font-semibold rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-apple-fill"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/20 text-background-50 border border-background-50/40 font-semibold rounded-lg hover:bg-background-50/30 transition-colors duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-android-fill"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="relative z-10 flex-shrink-0">
            <div className="w-[200px] md:w-[240px] aspect-[9/16] rounded-2xl overflow-hidden bg-background-100 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20manga%20reading%20app%20interface%20on%20screen%2C%20colorful%20manga%20page%20visible%20with%20speech%20bubbles%2C%20clean%20modern%20UI%20design%2C%20warm%20coral%20and%20white%20color%20scheme%2C%20minimalist%20phone%20frame%2C%20isolated%20on%20transparent%20background%2C%20app%20store%20style%20presentation%20mockup&width=480&height=854&seq=manga-app-mockup&orientation=portrait"
                alt="酷看漫画 App 移动端阅读界面"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}